var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 49.6093C34.5217 53.6345 34.0008 58.5649 34.0008 64.5371C34.0008 41.72 26.3944 34.1155 3.5791 34.1155C26.3963 34.1155 34.0008 26.5091 34.0008 3.69385C34.0008 26.511 41.6071 34.1155 64.4224 34.1155C48.685 34.1155 40.1829 37.7341 36.4238 47.4674",
    fill: "#754BE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7004 49.6093C34.5217 53.6345 34.0008 58.5649 34.0008 64.5371C34.0008 41.72 26.3944 34.1155 3.5791 34.1155C26.3963 34.1155 34.0008 26.5091 34.0008 3.69385C34.0008 26.511 41.6071 34.1155 64.4224 34.1155C48.685 34.1155 40.1829 37.7341 36.4238 47.4674",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.001 2.18896V0.114502",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.001 68.1144V66.0399",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9258 34.1154H68.0002",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.1154H2.07446",
    stroke: "#754BE3",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ed2c05fb6e827a34e0799134949ff80b.svg";
export { ForwardRef as ReactComponent };